import { Route } from 'react-router-dom';
import { VCA } from './vca';

export const chatRoutes = [
  <Route
    key="vca"
    path="/virtual-care-assistant/:chatToken/*"
    element={<VCA />}
  />,
];
